// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationRecebimentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/revenue_conciliation_recebimentos/{period_id}
 * Returns the list of linked recebimentos for the payroll period.
 */
import type { Payroll_RecebimentoRow } from './Payroll_RecebimentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_RevenueConciliationRecebimentosResponseDados = Payroll_RecebimentoRow[];

export type Payroll_RevenueConciliationRecebimentosResponse = ApiResponse<Payroll_RevenueConciliationRecebimentosResponseDados>;

registerResponseContract('Payroll_RevenueConciliationRecebimentosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data_cadastro:      { type: 'string',  required: false },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_franquia_id:        { type: 'number',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      recebimento_valor_taxas:        { type: 'number',  required: false },
      recebimento_valor_liquido:      { type: 'number',  required: false },
      recebimento_provedor:           { type: 'string',  required: false },
      recebimento_origem:             { type: 'string',  required: true },
      recebimento_origem_id:          { type: 'number',  required: false },
      recebimento_registrado_por:     { type: 'string',  required: true },
      recebimento_registrado_por_id:  { type: 'string',  required: true },
      recebimento_id_externo:         { type: 'string',  required: false },
      recebimento_conta_externa_id:   { type: 'number',  required: false },
      recebimento_payroll_period_id:  { type: 'number',  required: false },
      recebimento_observacoes:        { type: 'string',  required: false },
      recebimento_data_disponivel:    { type: 'string',  required: false },
      compromisso_user_id:            { type: 'string',  required: false },
      compromisso_data:               { type: 'string',  required: false },
    },
  },
})
